{
  "seo": {
    "title": "Safety & Trust",
    "description": "How CuriPop protects children: COPPA-focused privacy practices, moderation, parent controls, and account safety.",
    "keywords": "coppa, child safety, trust, moderation, parent controls, child data privacy"
  },
  "hero": {
    "title": "Safety & Trust",
    "subtitle": "A parent-first overview of privacy, moderation, and child data controls."
  },
  "principles": {
    "items": [
      {
        "title": "COPPA-aligned child privacy",
        "body": "We limit child data collection to what is required for learning features and account function. We do not sell child data."
      },
      {
        "title": "Content moderation approach",
        "body": "Learning content is reviewed for age-appropriateness and educational quality before broad rollout across families."
      },
      {
        "title": "Parent controls and oversight",
        "body": "Parents manage child profiles, reading preferences, and account settings from a central dashboard with clear controls."
      },
      {
        "title": "Secure account handling",
        "body": "Authentication, consent handling, and session controls are designed to keep family access secure and manageable."
      }
    ]
  },
  "policies": {
    "title": "Detailed policy pages",
    "subtitle": "For full legal and policy details, review each policy below. This page is the practical summary parents ask for most often.",
    "links": {
      "privacy": "Privacy Policy",
      "terms": "Terms of Service",
      "cookies": "Cookie Policy"
    }
  },
  "cta": {
    "title": "Explore safely from day one",
    "subtitle": "Start free and set up your family with privacy and oversight controls from the first session.",
    "primary": "Start Free",
    "secondary": "Parent Overview"
  }
}
